export default "__VITE_ASSET__BRhEjGfn__";